import angular from 'angular'

import component from './delete-vehicle.component'

let module = angular.module('myGarageDeleteVehicleModule', [])

.component('myGarageDeleteVehicle', component)

.name

export default module



// WEBPACK FOOTER //
// ./src/app/pages/profile/my-garage/components/delete-vehicle/index.js